import { render, staticRenderFns } from "./OverlayGroupOrderForm.vue?vue&type=template&id=6f0a526c&"
import script from "./OverlayGroupOrderForm.vue?vue&type=script&lang=js&"
export * from "./OverlayGroupOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0a526c')) {
      api.createRecord('6f0a526c', component.options)
    } else {
      api.reload('6f0a526c', component.options)
    }
    module.hot.accept("./OverlayGroupOrderForm.vue?vue&type=template&id=6f0a526c&", function () {
      api.rerender('6f0a526c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/OverlayGroupOrderForm.vue"
export default component.exports